import React from "react";
import Alert, { AlertProps } from "antd/lib/alert";

interface AlertComponentProps extends AlertProps {}

const AlertComponent = (props: AlertComponentProps) => {
  let { ...antdProps } = props;
  return <Alert {...antdProps} />;
};

AlertComponent.propTypes = {};

export default AlertComponent;
